const EnvironmentEnums = Object.freeze({
  LOCALHOST: "LOCALHOST",
  DEV: "DEV",
  DEV2: "DEV2",
  SIT: "SIT",
  PREPROD: "PREPROD",
  DEMO: "DEMO",
  DEMO2: "DEMO2",
  UAT: "UAT",
  PROD: "PROD",
});

export default EnvironmentEnums;